import React, { useState } from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styles from './modals.module.scss';

interface ApprovalModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (changeSubentries: boolean) => void;
  loading?: boolean;
  hasSubentries?: boolean;
}

const ApprovalModal: React.FC<ApprovalModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  loading = false,
  hasSubentries = false
}) => {
  const [changeSubentries, setChangeSubentries] = useState<boolean>(false);
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span className={styles.modalTitle}>Approve Status</span>
          <CloseOutlined 
            onClick={onCancel}
            style={{ cursor: 'pointer', color: 'var(--app-accent-color)', fontSize: '16px' }}
          />
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={() => onConfirm(changeSubentries)}
      confirmLoading={loading}
      okText="Continue"
      cancelText="Cancel"
      footer={null}
      className={styles.modal}
      width={600}
    >
      <div style={{ padding: '24px' }}>
        <p style={{ color: '#fff', fontSize: '14px', lineHeight: '1.5', margin: '0 0 24px 0' }}>
          All comments will be resolved for approved status. Would you like to continue with approval?
        </p>
        
        {/* Subentries Option - Only for items with subentries */}
        {hasSubentries && (
          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <input
                type="checkbox"
                id="changeSubentriesApproval"
                checked={changeSubentries}
                onChange={(e) => setChangeSubentries(e.target.checked)}
                style={{ 
                  width: '16px', 
                  height: '16px',
                  accentColor: 'var(--app-accent-color)'
                }}
              />
              <label htmlFor="changeSubentriesApproval" style={{ color: '#fff', fontSize: '14px' }}>
                Change status of sub-items as well
              </label>
            </div>
            <p style={{ fontSize: '12px', color: '#999', marginLeft: '28px' }}>
              If this option is checked, the status of all files, folders, versions and sub-items under the selected item will also be changed to approved status.
            </p>
          </div>
        )}
        
        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '8px 16px',
              background: 'transparent',
              border: '1px solid #666',
              color: '#fff',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(changeSubentries)}
            disabled={loading}
            style={{
              padding: '8px 16px',
              background: 'var(--app-accent-color)',
              border: '1px solid var(--app-accent-color)',
              color: '#000',
              borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? 'Processing...' : 'Continue'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalModal; 